const defaultCommonConf = {
  isRechargeStatStart: false,
  isRechargeStatEnd: false,
  isRewardStart: false,
  isRewardEnd: false,
  rechargeStatStartTime: 1783616400,
  rechargeStatEndTime: 1784480399,
  rewardStartTime: 1783616400,
  rewardEndTime: 1785085199,
  serverTime: 1781251073,
  activityPropConfigList: [
    {
      propType: 1,
      propId: 'ACTIVITY_SWIM_RING',
      propName: '游泳圈',
      propDesc: '泳池派对活动道具',
      propIcon: '',
      propNameAll: '游泳圈'
    },
    {
      propType: 1,
      propId: 'ACTIVITY_WATER_GUN',
      propName: '水枪',
      propDesc: '泳池派对活动道具',
      propIcon: '',
      propNameAll: '水枪'
    },
    {
      propType: 1,
      propId: 'ACTIVITY_SUN_UMBRELLA',
      propName: '遮阳伞',
      propDesc: '泳池派对活动道具',
      propIcon: '',
      propNameAll: '遮阳伞'
    },
    {
      propType: 1,
      propId: 'ACTIVITY_SWIM_GOGGLES',
      propName: '泳镜',
      propDesc: '泳池派对活动道具',
      propIcon: '',
      propNameAll: '泳镜'
    }
  ],
  dailyRewardConfigList: [
    {
      dayIndex: 1,
      rewardCode: 'DAILY_GAME_DAY_1',
      gameProps: [
        { propType: 2, propId: '80102101', propName: '金鑽抽獎券', propIcon: '', count: 1 },
        { propType: 2, propId: '80103001', propName: '排位保護卡', propIcon: '', count: 1 },
        { propType: 2, propId: '70100013', propName: '秘寶券', propIcon: '', count: 10 }
      ]
    },
    {
      dayIndex: 2,
      rewardCode: 'DAILY_GAME_DAY_2',
      gameProps: [
        { propType: 2, propId: '80102101', propName: '金鑽抽獎券', propIcon: '', count: 2 },
        { propType: 2, propId: '80103002', propName: '排位雙倍加分卡', propIcon: '', count: 1 },
        { propType: 2, propId: '70100013', propName: '秘寶券', propIcon: '', count: 20 }
      ]
    },
    {
      dayIndex: 3,
      rewardCode: 'DAILY_GAME_DAY_3',
      gameProps: [
        { propType: 2, propId: '70100101', propName: '金鑽', propIcon: '', count: 50 },
        { propType: 2, propId: '81010999', propName: '萬能成長幣', propIcon: '', count: 50 },
        { propType: 2, propId: '70100014', propName: '秘寶鑰匙', propIcon: '', count: 1 }
      ]
    },
    {
      dayIndex: 4,
      rewardCode: 'DAILY_GAME_DAY_4',
      gameProps: [
        { propType: 2, propId: '80102101', propName: '金鑽抽獎券', propIcon: '', count: 4 },
        { propType: 2, propId: '80103002', propName: '排位雙倍加分卡', propIcon: '', count: 2 },
        { propType: 2, propId: '70100013', propName: '秘寶券', propIcon: '', count: 40 }
      ]
    },
    {
      dayIndex: 5,
      rewardCode: 'DAILY_GAME_DAY_5',
      gameProps: [
        { propType: 2, propId: '80102101', propName: '金鑽抽獎券', propIcon: '', count: 5 },
        { propType: 2, propId: '80103002', propName: '排位雙倍加分卡', propIcon: '', count: 2 },
        { propType: 2, propId: '70100013', propName: '秘寶券', propIcon: '', count: 50 }
      ]
    },
    {
      dayIndex: 6,
      rewardCode: 'DAILY_GAME_DAY_6',
      gameProps: [
        { propType: 2, propId: '80102101', propName: '金鑽抽獎券', propIcon: '', count: 6 },
        { propType: 2, propId: '80103002', propName: '排位雙倍加分卡', propIcon: '', count: 2 },
        { propType: 2, propId: '70100013', propName: '秘寶券', propIcon: '', count: 60 }
      ]
    },
    {
      dayIndex: 7,
      rewardCode: 'DAILY_GAME_DAY_7',
      gameProps: [
        { propType: 2, propId: '70100101', propName: '金鑽', propIcon: '', count: 100 },
        { propType: 2, propId: '81010999', propName: '萬能成長幣', propIcon: '', count: 100 },
        { propType: 2, propId: '70100014', propName: '秘寶鑰匙', propIcon: '', count: 3 }
      ]
    }
  ],
  accumulateRechargeConfigList: [
    {
      rewardCode: 'ACCUMULATE_TIER_1000',
      needRechargeDiamondCount: 1000,
      displayOrder: 1
    },
    {
      rewardCode: 'ACCUMULATE_TIER_2000',
      needRechargeDiamondCount: 2000,
      displayOrder: 2
    },
    {
      rewardCode: 'ACCUMULATE_TIER_3000',
      needRechargeDiamondCount: 3000,
      displayOrder: 3
    }
  ],
  welcomeRewardGameProps: [
    { propType: 2, propId: '80102101', propName: '金鑽抽獎券', propIcon: '', count: 1 },
    { propType: 2, propId: '80202003', propName: '槍械三階升級卡', propIcon: '', count: 5 }
  ],
  exchangeRewardGameProps: [
    {
      propType: 2,
      propId: '90301907',
      propName: '【頭像框】泳池派對',
      propIcon: '',
      count: 1
    }
  ]
}

const defaultUserDetail = {
  isReceivedWelcomeReward: false,
  isExchanged: false,
  canExchange: false,
  totalRechargeDiamondCount: 0,
  activityPropList: [],
  dailyRewardStatusList: [
    {
      dayIndex: 1,
      status: 0
    },
    {
      dayIndex: 2,
      status: 0
    },
    {
      dayIndex: 3,
      status: 0
    },
    {
      dayIndex: 4,
      status: 0
    },
    {
      dayIndex: 5,
      status: 0
    },
    {
      dayIndex: 6,
      status: 0
    },
    {
      dayIndex: 7,
      status: 0
    }
  ],
  accumulateRewardStatusList: [
    {
        rewardCode: 'ACCUMULATE_TIER_1000',
        needRechargeDiamondCount: 1000,
        status: 0
    },
    {
        rewardCode: 'ACCUMULATE_TIER_2000',
        needRechargeDiamondCount: 2000,
        status: 0
    },
    {
        rewardCode: 'ACCUMULATE_TIER_3000',
        needRechargeDiamondCount: 3000,
        status: 0
    }
  ]
}

export const getDefaultCommonConf = () => defaultCommonConf
export const getDefaultUserDetail = () => defaultUserDetail